import React from 'react'
import styles from './index.module.less'

export default ({ children }) => {
  return <span className={styles.highlightFont}>
    {children}
  </span>
}
